<!--
 * @Descripttion: 分类
 * @FilePath: /mall-wap-vue/src/views/category/index.vue
 * @Author: 张兴业
 * @Date: 2020-09-24 15:41:31
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-11-10 15:21:48
-->
<template>
  <div>
    <title-bar-search>
      <div class="input_s clearfix" @click="goSearch">
        <img
          src="@/assets/common/icon_search_search@2x.png"
          alt="select"
          class="search_img left"
        />
        <div class="search_name left"></div>
      </div>
    </title-bar-search>
    <div class="cate_list">
      <div class="cate_list_left">
        <category-left @switchTab="switchTab" />
      </div>
      <div class="cate_list_right">
        <category-right @goAll="goAll" :leftIndex="leftIndex" />
      </div>
    </div>
  </div>
</template>
<script>
const TitleBarSearch = () =>
  import("@/components/TitleBarSearch").then(m => m.default || m);
const CategoryLeft = () =>
  import("./components/CategoryLeft").then(m => m.default || m);
const CategoryRight = () =>
  import("./components/CategoryRight").then(m => m.default || m);
export default {
  name: "categroy",
  components: {
    CategoryLeft,
    TitleBarSearch,
    CategoryRight
  },
  data() {
    return {
      leftIndex: 0,
      childIndex: 0
    };
  },
  computed: {
    categoriesList() {
      return this.$store.getters.categoriesList;
    }
  },
  created() {
    this.getData();
    // console.log(this.categoriesList, "categoriesList");
  },
  methods: {
    // 获取数据
    getData() {
      this.$store
        .dispatch("product/queryCategories", { slug: this.slug })
        .then(() => {})
        .catch(() => {});
    },
    switchTab(index) {
      this.leftIndex = index;
      // console.log(index);
    },
    // 全部一级分类
    goAll(childIndex, name, id) {
      this.childIndex = childIndex;
      this.$router.push({
        path: "/category/firstproduct",
        query: {
          categoryId: id
        }
      });
    },
    // 搜索跳转
    goSearch() {
      this.$router.push("/search");
    }
  }
};
</script>

<style lang="less" scoped>
.input_s {
  text-align: left;
  background: #fff;
  border-radius: 17px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  height: 34px;
  .search_name {
    margin-left: 12px;
    margin-top: auto;
    margin-bottom: auto;
    font-weight: 400;
    color: #222;
    padding: 8px 0;
    opacity: 0.38;
  }
  .search_img {
    // margin-top: 2px;
    margin-left: 8px;
    width: 24px;
    margin-top: auto;
    margin-bottom: auto;
  }
}
.cate_list {
  padding: 46px 0 50px;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  .cate_list_left {
    overflow-y: auto;
    height: calc(100vh - 96px);
  }
  .cate_list_right {
    background: #fff;
  }
}
</style>
